import Amenities from "./ameneties/amenities";
import Divider from "./divider";
import HouseCoordinates from "./houseCoordinates";
import HouseMainInfo from "./houseMainInfo";
import HouseWinners from "./houseWinners";
import MainCarousel from "./mainCarousel";
import PhotoTour from "./photoTour";
import ProgressBar from "./progressBar";
import PropertySurroundings from "./propertySurroundings";
import Widget from "./widget";
import HousePrizeDetails from "./housePrizeDetails";
import AllCompetitions from "./allCompetitions";
import WinnersFeedGrid from "../../home/winnersFeed/WinnersFeedGrid";
import PrestigeVillageCredit from "@/app/shared-components/PrestigeVillageCredit";

const HouseCompetitionForDesktop = () => (
  <div className="gap-8 flex">
    <section className="flex flex-col gap-8" style={{ width: "899px" }}>
      <MainCarousel />
      <HouseMainInfo />
      <ProgressBar />
      <div className="grid grid-cols-2 gap-4">
        <Amenities isDesktop={true} />
        <PropertySurroundings />
      </div>
      <PrestigeVillageCredit />
      <Widget />
      <Divider />
      <HouseWinners />
      <PhotoTour />
      <Divider />
      <HouseCoordinates />
      <Divider />
      <AllCompetitions />
      <WinnersFeedGrid />
    </section>
    {/* Right Column - Sticky */}
    <section className="w-[420px] h-fit sticky top-[6.5rem] self-start">
      <HousePrizeDetails />
    </section>
  </div>
);

export default HouseCompetitionForDesktop;
